import CollaboratorsIcon from '@/CustomIcons/CollaboratorsIcon'
import { AnalyticsEvents } from '@/services/AnalyticsService'
import useAnalytics from '@/services/useAnalytics'
import useMiscRoomActions from '@/services/useMiscRoomActions'
import MenuButton from '@/UIComponents2/MenuButton/MenuButton'
import { useTranslation } from 'react-i18next'

type CollaboratorsMenuButtonProps = {
    labelPosition?: 'inside' | 'outside'
    triggerClassName?: string
}
const CollaboratorsMenuButton = (props: CollaboratorsMenuButtonProps) => {
    const { t } = useTranslation()
    const { setShowWaitingRoomPopup } = useMiscRoomActions()
    const { logUserActivityWithContext } = useAnalytics()

    return (
        <MenuButton
            label={t('Invite')}
            icon={<CollaboratorsIcon style={{ fontSize: '1.3rem' }} />}
            labelPosition={props.labelPosition}
            triggerClassName={props.triggerClassName}
            onIconClick={() => {
                setShowWaitingRoomPopup(true)
                logUserActivityWithContext(AnalyticsEvents.CLICKED_INVITE_COLLABORATORS_BUTTON, {
                    componentSource: 'CollaboratorsMenuButton',
                })
            }}
        />
    )
}

export default CollaboratorsMenuButton
